// extracted by mini-css-extract-plugin
export default {"container":"CallToAction_container__s6a6s","heading":"CallToAction_heading__Rcjqf","button":"CallToAction_button__ioe7q"};